/**
 * ============================================================
 * 结尾文字图片配置
 * ============================================================
 * PC 和移动端共用此配置
 *
 * 图片位于页面最右端，滚动到此位置后整体淡出消失
 *
 * src              - 图片路径
 * top              - 距顶部距离（设计坐标，基于1080高度）
 * height           - 图片高度（设计坐标）
 * offsetFromRight  - 图片右边缘距场景右边缘的距离（设计坐标）
 * fadeOutDelay     - 滚动到位后多久开始淡出（秒）
 * fadeOutDuration  - 淡出动画持续时间（秒）
 * zIndex           - 层级
 */
export var endingSrc = './xiangan/九年，雄安新区 从\u201c一张白纸\u201d到\u201c拔节生长\u201d 从\u201c规划蓝图\u201d到\u201c现实画卷\u201d 这趟公交车 承载着无数个人的梦想与奋斗 正在将未来.png';
export var endingTop = 100;
export var endingHeight = 663;
export var endingOffsetFromRight = 300;
export var endingFadeOutDelay = 0.3;
export var endingFadeOutDuration = 1.5;
export var endingDuration = 1.5;
export var endingZIndex = 12;
